import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Autocomplete from "@mui/material/Autocomplete";
import CustomerService from "../services/customerService";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import HeightBox from "../components/HeightBox";
import { EMPLOYEE_BLUE, WHITE } from "../colors";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { AddFinancialRecordContainerModel } from "../containers/AddFinancialRecordModelContainer";
import FinService from "../services/finService";
import { red } from "@mui/material/colors";
import Banner from "../components/banners/Banner";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomers } from "../actions/customers";
import { getAllFinances } from "../actions/finances";
import FinancialComparison from "../components/widgets/FinancialComparison";
import {
  AIR_TICKET,
  BUREAU,
  BUS_FAIR_1,
  BUS_FAIR_2,
  BUS_FAIR_3,
  CESS_PAYMENT,
  EMBACY,
  EMBASSY,
  ENDORSEMENT,
  FOREIGN_AGENT_LOST,
  IMMIGRATION,
  INSURANCE_AGREEMENT,
  MEDICAL,
  MEDICAL_CHOP,
  OTHERS,
  Passport_CREATE,
  PCR,
  POLICE_REPORT_CHOP,
  RMB,
  TRAINING,
} from "../constants/finTypes";
import { VISA } from "../constants/mediaType";
import { DateTime } from "luxon";

const CustomInput = styled(TextField)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontSize: 18,
  backgroundColor: WHITE,
  borderRadius: 10,
  minWidth: 100,
}));

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  padding: 10,
  textAlign: "center",
}));

function getSum(total, num) {
  return total + Math.round(num);
}
const Financial = () => {
  const dispatch = useDispatch();

  const customerList = useSelector((state) => state.customerList);
  const { loading, error, customers } = customerList;
  const financeList = useSelector((state) => state.financeList);
  const { user } = useSelector((state) => state.auth);
  const { finances } = financeList;
  const [openModel, setOpenModel] = useState(false);
  const [isNewFinAdded, setIsNewFinAdded] = useState(false);
  const [userSearched, setUserSearched] = useState(false);
  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    finances: [],
    customers: [],
    totalExpense: 0,
    totalIncome: 0,
    filteredFinances: [],
  });
  const [searchParams, setSearchParams] = useState({
    startDate: "",
    endDate: "",
    searchedUser: "",
    searchedType: "",
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    const getPageInfo = async () => {
      if (customers === null) {
        dispatch(getAllCustomers());
      }
      if (finances === null) {
        dispatch(getAllFinances());
      }
      var allExp = 0;
      var allIncome = 0;
      finances?.forEach((fin) => {
        if (fin?.isExpense) {
          allIncome += Number(fin?.amount);
        } else {
          allExp += Number(fin?.amount);
        }
      });

      const temp = customers?.map((item) => {
        return { label: item.reg_number, value: item.full_name };
      });

      setScreenInfo({
        ...screenInfo,
        finances: finances,
        totalExpense: allIncome.toFixed(2),
        totalIncome: allExp.toFixed(2),
        customers: temp,
        filteredFinances: finances,
      });
      setIsDataLoaded(false);
    };

    getPageInfo();
  }, [finances]);
  useEffect(() => {
    const getPageInfo = async () => {
      setIsDataLoaded(true);

      var allExp = 0;
      var allIncome = 0;
      finances.forEach((fin) => {
        if (fin.isExpense) {
          allIncome += Number(fin.amount);
        } else {
          allExp += Number(fin.amount);
        }
      });

      const temp = customers?.map((item) => {
        return { label: item.full_name, value: item.full_name };
      });

      setScreenInfo({
        ...screenInfo,
        finances: finances,
        totalExpense: allIncome.toFixed(2),
        totalIncome: allExp.toFixed(2),
        customers: temp,
      });
      setIsDataLoaded(false);
    };

    if (isNewFinAdded) {
      getPageInfo();
      dispatch(getAllFinances());
      setIsNewFinAdded(false);
    }
  }, [isNewFinAdded]);
  useEffect(() => {
    let filteredFinances = finances;
    if (searchParams.startDate !== "") {
      filteredFinances = filteredFinances.filter(
        (fin) =>
          DateTime.fromISO(fin.createdAt).toISO(DateTime.DATE_SHORT) >=
          DateTime.fromISO(searchParams.startDate).toISO(DateTime.DATE_SHORT)
      );
    }
    if (searchParams.endDate !== "") {
      filteredFinances = filteredFinances.filter(
        (fin) =>
          DateTime.fromISO(fin.createdAt).toISO(DateTime.DATE_SHORT) <=
          DateTime.fromISO(searchParams.endDate).toISO(DateTime.DATE_SHORT)
      );
    }
    if (searchParams.searchedUser !== "" && searchParams.searchedUser !== "All") {
      filteredFinances = filteredFinances.filter((fin) => fin.Customer.full_name.includes(searchParams.searchedUser));
    }

    if (searchParams.searchedType !== "" && searchParams.searchedType !== "All") {
      filteredFinances = filteredFinances.filter((fin) => fin.type === searchParams.searchedType);
    }
    if (
      searchParams.endDate !== "" ||
      searchParams.startDate !== "" ||
      searchParams.searchedUser !== "" ||
      searchParams.searchedType !== ""
    ) {
      var allExp = 0;
      var allIncome = 0;
      filteredFinances?.forEach((fin) => {
        if (fin.isExpense) {
          allExp += Number(fin.amount);
        } else {
          allIncome += Number(fin.amount);
        }
      });

      var totalEarning =
        user?.role === 1 ? (allIncome.toFixed(2) - allExp.toFixed(2)).toFixed(2) : allIncome.toFixed(2);
      setScreenInfo({
        ...screenInfo,
        filteredFinances: filteredFinances,
        totalExpense: allExp.toFixed(2),
        totalIncome: totalEarning,
      });
    }
  }, [searchParams]);
  const clearSearchParams = () => {
    setSearchParams({
      startDate: "",
      endDate: "",
      searchedUser: "",
      searchedType: "",
    });
  };
  const finTypes = [
    { label: "All", value: "All", id: "0" },
    { label: BUS_FAIR_1, value: BUS_FAIR_1, id: "1" },
    { label: BUS_FAIR_2, value: BUS_FAIR_2, id: "2" },
    { label: BUS_FAIR_3, value: BUS_FAIR_3, id: "3" },
    { label: Passport_CREATE, value: Passport_CREATE, id: "4" },
    { label: ENDORSEMENT, value: ENDORSEMENT, id: "5" },
    { label: IMMIGRATION, value: IMMIGRATION, id: "6" },
    { label: TRAINING, value: TRAINING, id: "7" },
    { label: VISA, value: VISA, id: "8" },
    { label: INSURANCE_AGREEMENT, value: INSURANCE_AGREEMENT, id: "9" },
    { label: EMBACY, value: EMBACY, id: "10" },
    { label: POLICE_REPORT_CHOP, value: POLICE_REPORT_CHOP, id: "11" },
    { label: RMB, value: RMB, id: "12" },
    { label: BUREAU, value: BUREAU, id: "13" },
    { label: AIR_TICKET, value: AIR_TICKET, id: "14" },
    { label: MEDICAL, value: MEDICAL, id: "15" },
    { label: MEDICAL_CHOP, value: MEDICAL_CHOP, id: "16" },
    { label: EMBASSY, value: EMBASSY, id: "17" },
    { label: CESS_PAYMENT, value: CESS_PAYMENT, id: "18" },
    { label: PCR, value: PCR, id: "19" },
    { label: OTHERS, value: OTHERS, id: "20" },
    { label: FOREIGN_AGENT_LOST, value: FOREIGN_AGENT_LOST, id: "21" },
  ];

  return (
    <div>
      <AddFinancialRecordContainerModel
        openModel={openModel}
        cancelFunction={() => setOpenModel(false)}
        setIsNewFinAdded={setIsNewFinAdded}
      />
 
       <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
          }}
        >
      <Stack direction="row" spacing={2}>
        <Autocomplete
          value={searchParams.searchedUser}
          id="combo-box-demo"
          options={[{ label: "All", value: "All" }, ...(screenInfo?.customers ?? [])]}
          onChange={(event, value) => {
            if (value === null || value === undefined) {
              setSearchParams({
                ...searchParams,
                searchedUser: "",
              });
            } else {
              setSearchParams({
                ...searchParams,
                searchedUser: value?.label,
              });
            }
          }}
          renderInput={(params) => <CustomInput {...params} placeholder="Customer" style={{ width: 200 }} />}
        />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={finTypes}
          value={searchParams.searchedType}
          inputValue={searchParams.searchedType}
          onChange={(event, value) => {
            setSearchParams({ ...searchParams, searchedType: value.value });
          }}
          renderInput={(params) => <CustomInput {...params} placeholder="Select type" style={{ width: 200 }} />}
        />
        <CustomInput
          type="date"
          value={searchParams.startDate}
          onChange={(event, value) => {
            setSearchParams({
              ...searchParams,
              startDate: event.target.value,
            });
          }}
        />
        <CustomInput
          type="date"
          value={searchParams.endDate}
          onChange={(event, value) => {
            setSearchParams({
              ...searchParams,
              endDate: event.target.value,
            });
          }}
        />

        <CustomButton style={{ color: EMPLOYEE_BLUE }} onClick={clearSearchParams}>
          Clear
        </CustomButton>
        {/* {user?.role === 1 && ( */}  
          <CustomButton style={{ backgroundColor: EMPLOYEE_BLUE, color: WHITE ,minWidth:132 }} onClick={() => setOpenModel(true)}>
            Add Record
          </CustomButton>
        {/* )} */}
      </Stack>
      </Box>
      <HeightBox height={20} />
      
      <Stack direction="row" spacing={10}>
        
      <Box
          sx={{
            width: "100%",

            display: "flex",
            justifyContent: "left",
            alignItems: "left",
          }}
        >
          <FinancialComparison
            people={customers}
            expenses={screenInfo.filteredFinances?.filter((f) => f.isExpense)}
            incomes={user?.role === 1 ? screenInfo.filteredFinances?.filter((f) => !f.isExpense) : []}
            isAdminPermitted={user?.role === 1}
          />
        </Box>
          
        <Box
          sx={{
            width: "50%",

            display: "flex",
            justifyContent: "left",
            alignItems: "left",
          }}
        >
          <Container style={{width:"100%"}} elevation={2}>

            <Typography fontSize={40} fontWeight="bold">
              Cash Flow
            </Typography>
            <HeightBox height={60} />

            {user?.role === 1 && (
              <>
              <Stack direction="row" justifyContent="space-between">
              <Typography fontSize={15}>Income</Typography>
              <Typography fontSize={15}>{screenInfo.totalIncome}</Typography>
            </Stack>
            <HeightBox height={20} />
            <LinearProgress
              value={Math.round(
                (parseFloat(screenInfo.totalIncome) /
                  (parseFloat(screenInfo.totalIncome) + parseFloat(screenInfo.totalExpense))) *
                  100
              )}
              variant="determinate"
              color="success"
            />
                </>
            )}
            <HeightBox height={20} />

            <Stack direction="row" justifyContent="space-between">
                  <Typography fontSize={15}>Expense</Typography>
                  <Typography fontSize={15}>{screenInfo.totalExpense}</Typography>
            </Stack>
            <HeightBox height={20} />


            <LinearProgress
              value={Math.round(
                    (parseFloat(screenInfo.totalExpense) /
                      (parseFloat(screenInfo.totalIncome) + parseFloat(screenInfo.totalExpense))) * 100 )}
                  variant="determinate"
                  color="error"
            />
          </Container>
        </Box>
      {/* table start here */}

      </Stack>
    

      <HeightBox height={20} />

      <Typography fontSize={18}>Records</Typography>
      <HeightBox height={10} />
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded &&
        (screenInfo.filteredFinances?.length > 0 ? (
          <>
            <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
              <Table
                sx={{
                  minWidth: 650,
                  backgroundColor: WHITE,
                }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Time</TableCell>
                    <TableCell align="center">Type</TableCell>
                    <TableCell align="center">Customer</TableCell>
                    <TableCell align="center">Reason</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    <TableCell align="center">Related Documents</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {screenInfo.filteredFinances?.map((row) => (
                    <>
                      {user?.role === 1 ? (

                        <TableRow
                          hover
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell>{row.dateTimeCreated}</TableCell>
                          <TableCell align="center">{row.type}</TableCell>
                          <TableCell align="center">{row.Customer.full_name}</TableCell>
                          <TableCell align="center">{row.description}</TableCell>
                          <TableCell align="center">
                            {row.isExpense ? (
                              <span style={{ color: "red", fontWeight: "bold" }}>-{row.amount}</span>
                            ) : (
                              <span style={{ color: "green", fontWeight: "bold" }}>+{row.amount}</span>
                            )}
                          </TableCell>
                          <TableCell align="center">-</TableCell>
                        </TableRow>
                      ) : (
                        row.isExpense && (
                          <TableRow
                            hover
                            key={row.id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell>{row.dateTimeCreated}</TableCell>
                            <TableCell align="center">{row.type}</TableCell>
                            <TableCell align="center">{row.Customer.full_name}</TableCell>
                            <TableCell align="center">{row.description}</TableCell>
                            <TableCell align="center">
                              <span style={{ color: "red", fontWeight: "bold" }}>-{row.amount}</span>
                            </TableCell>
                            <TableCell align="center">-</TableCell>
                          </TableRow>
                        )
                      )}
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : (
          <Banner message={"No financial records found"} />
        ))}
    </div>
  );
};

export default Financial;
